/* eslint-disable max-len,max-len */

import React from 'react';
//10000 errors are our own created in desktop doftware
//11000 errors are created on the front end and are generally to do with the socket
//rest are LaMotte errors

/* eslint-enable max-len */

export function getErrorCode(code, scannerName) {

  let errorCodeDescription = getErrorList();

  try {
    code = Math.abs(code);
  } catch (e) {
    console.log('Error Code Error', e);
  }
  if (errorCodeDescription[code]) {
    if (scannerName && errorCodeDescription[code].indexOf('[Scanner Name]') > -1) {
      const msg = errorCodeDescription[code].replace('[Scanner Name]', scannerName);

      return (
        <span>{msg}
          <div>{'Error Code: ' + getErrorCodeAbv(code)}</div>
        </span>);
    } else {
      return (
        <span>
          {errorCodeDescription[code]}
          <div>{'Error Code: ' + getErrorCodeAbv(code)}</div>
        </span>);
    }
  } else {
    if (code >= 257 && code <= 512) {
      return (
        <span>{errorCodeDescription['defaultOverfill']}
          <div>{'Error Code: ' + getErrorCodeAbv(code)}</div>
        </span>);
    } else if (code < 10000) {
      return (
        <span>{errorCodeDescription['defaultLamotte']}
          <div>{'Error Code: ' + getErrorCodeAbv(code)}</div>
        </span>);
    } else {
      return (
        <span>{errorCodeDescription['defaultFrontEnd']}
          <div>{'Error Code: ' + getErrorCodeAbv(code)}</div>
        </span>);
    }
  }
}

export function getErrorCodeText(code, scannerName) {
  let errorCodeDescription = getErrorList();

  try {
    code = Math.abs(code);
  } catch (e) {
    console.log('Error Code Error', e);
  }
  if (errorCodeDescription[code]) {
    if (scannerName && errorCodeDescription[code].indexOf('[Scanner Name]') > -1) {
      return errorCodeDescription[code].replace('[Scanner Name]', scannerName);
    } else {
      return errorCodeDescription[code];
    }
  } else {
    if (code >= 257 && code <= 512) {
      return errorCodeDescription['defaultOverfill'];
    } else if (code < 10000) {
      return errorCodeDescription['defaultLamotte'];
    } else {
      return errorCodeDescription['defaultFrontEnd'];
    }
  }
}

const getErrorList = (formatMessage) => {

  if (undefined === formatMessage || null === formatMessage) {
    return {
      11001: 'There was a problem with the connection to the [Scanner Name], please refresh your page with the key sequence ctrl+shift+r.',
      11002: 'The ALEX Pro Test Connect Software is not running please restart the ALEX Pro Test Connect Service.',
      11003: 'ALEX Pro is not detecting your [Scanner Name] please make sure it is property connected and powered on.',
      11004: 'You can only perform one water test with the [Scanner Name] at a time. Please close any additional windows or browser tabs that are currently open.',
      11005: 'ALEX Pro Test Connect Cannot Find any Scanners please power cycle your scanner, ensure the USB cable is fully plugged in, restart ALEX Pro Test Connect and press the Keys ctrl+shift+r to refresh the page.',
      10001: 'There was a connection issue with your Smartlab. Ensure the USB cable is fully plugged in and the device is powered on. If the problem persists, contact Lamotte support at 800-344-3100 x3 or softwaresupport@lamotte.com.',
      10002: 'The ALEX Pro Test Connect software is out of date.  Please go to Tools, Devices and Download and install the latest version.',
      10003: 'There is already a scan in progress. Please close any additional windows or browser tests you have open. You can only perform one water test at a time.',
      501: 'You can only perform one water test with the [Scanner Name] at a time. Please close any additional windows or browser tabs that are currently open.',
      502: 'The SmartLab disk you are using is invalid. Please ensure you have selected and are using the correct disk and restart the test. If the problem persists, click "Feedback or Problem" or contact BioGuard Customer Care.',
      503: 'The SmartLab disk you are using is invalid. Please ensure you have selected and are using the correct disk and restart the test. If the problem persists, click "Feedback or Problem" or contact BioGuard Customer Care.',
      999: 'There was a connection issue with your Smartlab. Ensure the USB cable is fully plugged in and the device is powered on. If the problem persists, contact Lamotte support at 800-344-3100 x3 or softwaresupport@lamotte.com.',
      1: 'The Smartlab encountered an issue calculating results. If the problem persists, please contact Lamotte support at 800-344-3100 x 3 or softwaresupport@lamotte.com.',
      2: 'The Smartlab encountered an issue calculating results. If the problem persists, please contact Lamotte support at 800-344-3100 x 3 or softwaresupport@lamotte.com.',
      3: 'The Smartlab encountered an issue with the rotary encoder. Please contact Lamotte support at 800-344-3100 x3 or softwaresupport@lamotte.com',
      4: 'The Smartlab encountered an issue calculating results. If the problem persists, please contact Lamotte support at 800-344-3100 x 3 or softwaresupport@lamotte.com.',
      5: 'The [Scanner Name] motor stalled, if this problem persists contact Lamotte support at 800.344.3100 x3 or softwaresupport@lamotte.com',
      6: 'The [Scanner Name] motor cannot maintain constant speed, if this problem persists contact Lamotte support at 800.344.3100 x3 or softwaresupport@lamotte.com',
      7: 'The [Scanner Name] is not ready, ensure the lid is closed, the disk is properly seated, and the SmartLab is plugged into the PC and powered on.',
      8: 'The [Scanner Name] encountered an issue calculating results. If the problem persists, please contact Lamotte support at 800-344-3100 x 3 or softwaresupport@lamotte.com.',
      256: 'The LaMotte [Scanner Name] requires service, contact Lamotte support at 800.344.3100 x3 or softwaresupport@lamotte.com',
      defaultLamotte: 'The Smartlab encountered an error. Please contact Lamotte support at 800-344-3100 x3 or softwaresupport@lamotte.com.',
      defaultFrontEnd: 'There was a problem with the connection to your scanner, please refresh your page with the key sequence ctrl+shift+r and check that the Alex Pro Test Connect Service is running',
      defaultOverfill: 'The Smartlab encountered an issue calculating results. Please check you did not overfill.',
    };
  }

  return {
    11001: formatMessage({id: 'error.code.11001'}),
    11002: formatMessage({id: 'error.code.11002'}),
    11003: formatMessage({id: 'error.code.11003'}),
    11004: formatMessage({id: 'error.code.11004'}),
    11005: formatMessage({id: 'error.code.11005'}),
    10001: formatMessage({id: 'error.code.10001'}),
    10002: formatMessage({id: 'error.code.10002'}),
    10003: formatMessage({id: 'error.code.10003'}),
    501: formatMessage({id: 'error.code.501'}),
    502: formatMessage({id: 'error.code.502'}),
    503: formatMessage({id: 'error.code.503'}),
    999: formatMessage({id: 'error.code.999'}),
    1: formatMessage({id: 'error.code.1'}),
    2: formatMessage({id: 'error.code.2'}),
    3: formatMessage({id: 'error.code.3'}),
    4: formatMessage({id: 'error.code.4'}),
    5: formatMessage({id: 'error.code.5'}),
    6: formatMessage({id: 'error.code.6'}),
    7: formatMessage({id: 'error.code.7'}),
    8: formatMessage({id: 'error.code.8'}),
    256: formatMessage({id: 'error.code.256'}),
    defaultLamotte: formatMessage({id: 'error.code.defaultLamotte'}),
    defaultFrontEnd: formatMessage({id: 'error.code.defaultFrontEnd'}),
    defaultOverfill: formatMessage({id: 'error.code.defaultOverfill'}),
  };
};


function getErrorCodeAbv(code) {
  if (code > 10000) {
    return 'ALEX(' + code + ')';
  } else if (code < 10000) {
    return 'Lamotte(' + code + ')';
  } else {
    return 'Unknown';
  }
}
